export const cookieNames = {
    cookieSettings: "dewi-cookiesettings"
} as const
